export function customizeNewDate (additionInHours=0) {
    let current = new Date()
    current.setHours(current.getHours()+additionInHours)
    const ct = new Date(current)
    return ct
}

export function customizeEndCalendarDate (additionInMonths=12) {
  let current = new Date()
  current.setMonth(current.getMonth()+additionInMonths)
  const et = new Date(current)
  return et
}

export const getDisabledDates = (settings, periodLength=365) => {
  const workingDays = settings.business_hours?.working_days
  let time = new Date()

  if(!workingDays) { return }

  let daysOff = []
  let timestamp = time.setDate(time.getDate())

  for(let d = 1; d < periodLength; d++) {
    timestamp = time.setDate(time.getDate()+1)

    const dayOfTheWeek = new Date(timestamp).getDay()
    if(!workingDays.includes(dayOfTheWeek)) {
      daysOff.push(new Date(timestamp))
    }
  }
  return daysOff
}

export const groupBy = function(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const calcWeightData = (data, year) => {
  var fdw = data.filter((e) => {return ["2", "3", "76"].includes(e["Identifier"]) && e["year"]===year});
  fdw = groupBy(fdw, 'company_id');
  for (const [key, value] of Object.entries(fdw)) {
    const seventySix = value.find(v => v.Identifier === '76');
    let twoOrThree = value.find(v => v.Identifier === '2');
    if (!twoOrThree) {
      twoOrThree = value.find(v => v.Identifier === '3');
    }

    if (!seventySix || !twoOrThree) {
      fdw[key] = "Oil"
    } else {
      const w = (parseFloat(twoOrThree.value?.replaceAll(",", "")) || 0) / (parseFloat(seventySix.value?.replaceAll(",", "")) || 1);
      fdw[key] = w < 0.5 ? "Gas" : "Oil";
    }
  }
  return fdw;
}

export const calcWeightDataESG = (data, year) => {
  var fdw = data.filter((e) => {return ["19","21"].includes(e["Identifier"]) && e["year"]===year && e["value"] && e["value"] !== "NR"});
  fdw = groupBy(fdw, 'company_name');
  for (const [key, value] of Object.entries(fdw)) {
    if (value.length !== 2) {
      fdw[key] = "NR"
    } else {
      if (value[0]["Identifier"] === "19") {
        let w = (parseFloat(value[0]["value"]?.replaceAll(",",""))||0) / ((parseFloat(value[1]["value"]?.replaceAll(",",""))||1)*1000);
        if (w<0.5) {
          fdw[key] = "Gas"
        } else {
          fdw[key] = "Oil"
        }
      } else {
        let w = (parseFloat(value[1]["value"]?.replaceAll(",",""))||0) / ((parseFloat(value[0]["value"]?.replaceAll(",",""))||1)*1000);
        if (w<0.5) {
          fdw[key] = "Gas"
        } else {
          fdw[key] = "Oil"
        }
      }
    }
  }
  return fdw;
}

export const parseHours = val => {
    let date
    let formatter
    let formattedTime
    if(val !== null) {
        date = new Date(val)
        formatter = new Intl.DateTimeFormat('en-US', { hour: '2-digit', minute: '2-digit' });
        formattedTime = formatter.format(date);
    }
    return formattedTime
}

export const removeSeconds = (datestr) => {
    let s = datestr.split(":");
    let s2 = s[2]
    s2 = s2.split(" ")[1]
    return s[0]+":"+s[1]+" "+s2
}

export const convertRangeArrToFriendlyStr = arrayWithTwoNumbers => {
    return arrayWithTwoNumbers.toString().replace(',', '-')
}


export const renderArrayAsReadableString = arrVal => {
    if(arrVal?.length > 1) {
        let titlesStr = ''
        for(let i=0; i<arrVal.length; i++) {
            if(i === (arrVal.length-1)){
              titlesStr += arrVal[i]
            } else if(i === (arrVal.length-2)) {
              titlesStr += arrVal[i]
              titlesStr += ' and '
            } else {
              titlesStr += arrVal[i]
              titlesStr += ', '
            }
        }
        return titlesStr
    }
    if(arrVal?.length === 1) {
      return arrVal[0]
    }
}


export const debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

export function Median(data) {
  return Quartile_50(data);
}

export function Quartile_25(data) {
  return Quartile(data, 0.25);
}

export function Quartile_50(data) {
  return Quartile(data, 0.5);
}

export function Quartile_75(data) {
  return Quartile(data, 0.75);
}

export function Quartile(data, q) {
  data=Array_Sort_Numbers(data);
  var pos = ((data.length) - 1) * q;
  var base = Math.floor(pos);
  var rest = pos - base;
  if( (data[base+1]!==undefined) ) {
    return data[base] + rest * (data[base+1] - data[base]);
  } else {
    return data[base];
  }
}

export function Array_Sort_Numbers(inputarray){
  return inputarray.sort(function(a, b) {
    return a - b;
  });
}

export function Array_Sum(t){
   return t.reduce(function(a, b) { return a + b; }, 0);
}

export function Array_Average(data) {
  return Array_Sum(data) / data.length;
}

export function Array_Stdev(tab){
   var i,j,total = 0, mean = 0, diffSqredArr = [];
   for(i=0;i<tab.length;i+=1){
       total+=tab[i];
   }
   mean = total/tab.length;
   for(j=0;j<tab.length;j+=1){
       diffSqredArr.push(Math.pow((tab[j]-mean),2));
   }
   return (Math.sqrt(diffSqredArr.reduce(function(firstEl, nextEl){
            return firstEl + nextEl;
          })/tab.length));
}
